import { AsyncThunk, createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { axiosInstance } from '../../shared/api/axios-instance';
import { createPathParams } from '../../shared/utils/create-path-params/create-path-params.util';
import { Endpoints } from '../../shared/utils/endpoints-file.utils';
import { ReleaseDto } from '../dtos/release.dto';
import { ReleaseRequestModel } from '../models/release-request.model';
import { ReleaseModel } from '../models/release.model';
import {
  mapReleaseDtoToReleaseModel,
  mapReleaseRequestModelToReleaseRequestDto,
} from '../utils/releases-mapping.utils';

export const editAppRelease: AsyncThunk<
  ReleaseModel,
  ReleaseRequestModel,
  Record<string, unknown>
> = createAsyncThunk(
  'app/releases/edit-app-release',
  async (data: ReleaseRequestModel, { rejectWithValue }) => {
    try {
      const dataDto = mapReleaseRequestModelToReleaseRequestDto(data);
      const basePath = createPathParams<'releaseId'>(Endpoints.UPDATE_RELEASE, {
        releaseId: data.id,
      });
      const resp: AxiosResponse<ReleaseDto> = await axiosInstance.put(
        basePath,
        dataDto
      );
      return mapReleaseDtoToReleaseModel(resp.data);
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);
